import {
    FETCH_CREATE_PROJECTS_REQUEST,
    FETCH_CREATE_PROJECTS_SUCCESS,
    FETCH_CREATE_PROJECTS_FAILURE,
} from '../../actions/projects/create-project-action';

const initialState = {
    createdProject: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const CreateProjectReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_CREATE_PROJECTS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_CREATE_PROJECTS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                createdProject: { ...action.payload[0] },
            };
        case FETCH_CREATE_PROJECTS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default CreateProjectReducer;